<template>
  <component
    :is="tag"
    v-if="item"
    class="category-item"
    :class="[{ active: active }, categoryTypeClass]"
    :style="{
      padding: padding,
    }"
    @click="onClick">
    <slot>
      <i v-if="!item.parent && item.icon" class="icon typo-icon-20 mr-2" :class="item.icon" />
      <p class="typo-p14 typo-regular">{{ item.text }}</p>
      <span v-if="!item.hideBadge && categoryItemCount > 0" class="badge typo-p12 typo-regular">{{
        categoryItemCount
      }}</span>
    </slot>
  </component>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import type { MyLibraryStore } from '@modules/libraries/store/types';
import { mapState } from 'vuex';

export default defineComponent({
  name: 'CategoryItem',
  props: {
    item: Object,
    tag: {
      type: String,
      default: 'a',
    },
    stop: {
      type: Boolean,
      default: false,
    },
    prevent: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    padding: {
      type: String,
      default: '10px 24px',
    },
  },
  emits: ['selectItem'],
  data: () => ({}),
  computed: {
    ...mapState('library', {
      mylibrary: (state: any): MyLibraryStore => state.mylibrary,
      activeTab: (state: any) => state.activeTab,
    }),
    categoryTypeClass() {
      if (!this.item) {
        return '';
      }
      return this.item.parent ? 'child' : '';
    },
    categoryItemCount() {
      if (this.activeTab !== 'library') {
        return this.item?.count;
      }
      switch (this.item?.value) {
        case 'block': {
          return this.mylibrary.allBlocks;
        }
        case 'template': {
          return this.mylibrary.allTemplates;
        }
        default: {
          return this.mylibrary.allSaved;
        }
      }
    },
  },
  methods: {
    onClick(e: Event) {
      if (this.prevent) {
        e.preventDefault();
      }
      if (this.stop) {
        e.stopPropagation();
      }
      this.$emit('selectItem', this.item, e);
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';
.category-item {
  display: flex;
  align-items: center;
  color: $text-light-low;
  font-size: 14px;
  line-height: 150%;
  @include trans-all;
  cursor: pointer;
  border-left: 3px solid transparent;
  min-height: 40px;

  .badge {
    @include flex-center;
    background: $light3;
    min-width: 20px;
    padding: 2px 8px;
    border-radius: 200rem;
    margin-left: auto;
  }

  &.child {
    margin-left: 36px;
    position: relative;

    &:after {
      content: '';
      position: absolute;
      left: -3px;
      top: 0;
      width: 1px;
      height: 100%;
      background-color: $text-dark-high;
    }
    &.active {
      &:after {
        background-color: transparent;
      }
    }
  }

  &.active,
  &:hover {
    color: $text-light-high;
    background: rgba($dark0, 0.1);
    .badge {
      background: rgba($dark0, 0.1);
    }
  }

  &.active {
    cursor: default;
    border-left-color: $mono3;
  }
}
</style>
